<div class="modal-wrapper">
  <div cf-modal-header [hideCloseButton]="true"></div>

  <div class="modal-body">
    <div class="row" [formGroup]="form">
      <div class="col-12">
        <h5 class="mb-3">{{ "booking-password.title" | translate }}</h5>

        <cf-form-field>
          <input
            cf-input
            type="password"
            [placeholder]="'booking-password.placeholder' | translate"
            formControlName="password"
            autocomplete="new-password"
            value=""
          />
          <cf-input-error [error]="form.controls.password.errors"> {{ "auth.password" | translate }} </cf-input-error>
        </cf-form-field>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <cf-button (click)="checkPassword()">{{ "confirm" | translate }}</cf-button>
  </div>
</div>
